import { LoadMore } from '@tbitop/mobile-app';
import classNames from 'classnames';
import { ObjektListItem } from './objekt-list-item';
import type { Objekt } from './objekt-list-types';

type ObjektListProps = {
  objekte: Objekt[];
  className?: string;
  pageLoading?: boolean;
  pagination?: {
    hasMore: boolean;
    fetchMore: () => Promise<void>;
  };
};

export const ObjektList = ({ objekte, pagination, className, pageLoading }: ObjektListProps) => (<>
  <ul className={classNames('overflow-y-auto', className)} aria-label="Objektliste">
    {objekte.map(objekt => (
      <ObjektListItem objekt={objekt} key={objekt.id} />
    ))}
  </ul>
  {!pageLoading && !!pagination && <LoadMore hasMore={pagination.hasMore} onLoadMore={() => pagination.fetchMore()} />}
</>
);
